import { render, staticRenderFns } from "./MergingTwoNgos.vue?vue&type=template&id=6cf82aa4&"
import script from "./MergingTwoNgos.vue?vue&type=script&lang=js&"
export * from "./MergingTwoNgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports